import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import ChartAnnotation from "chartjs-plugin-annotation";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  Title,
  ChartAnnotation
);

const COLORS = [
  "#D4A06F",
  "#85D46F",
  "#6F95D4",
  "#D46FD0",
  "#D4786F",
  "#CFD486",
  "#df979e",
  "#d7658b",
  "#c80064",
];

const WeeklyRevenueChart = ({ data }) => {
  const currentMonthShort = new Date()
    .toLocaleString("default", {
      month: "short",
    })
    .slice(0, 3);

  // Filter and flatten current month data
  const currentMonthData = data.filter((item) =>
    item.weekLabel.startsWith(currentMonthShort)
  );

  const groupedByMonth = data.reduce((acc, item) => {
    const month = item.weekLabel.split("-")[0]; // e.g., "Apr"
    if (!acc[month]) acc[month] = [];
    acc[month].push(item);
    return acc;
  }, {});

  const PRODUCT_LABELS = {
    "practical training": "Farm Training",
    "physical site inspection": "Physical Site Inspection",
    "hydroponic masterclass": "Hydroponic Masterclass",
    allother: "Allother",
    "site inspection kit": "Site Inspection Kit",
    "aif project report": "Aif Project Report",
  };

  const months = Object.keys(groupedByMonth);
  const products = Array.from(
    new Set(data.flatMap((item) => Object.keys(item.revenue)))
  );

  // Step 2: Build chart data
  const chartData = {
    labels: [],
    datasets: products.map((product, index) => ({
      label: PRODUCT_LABELS[product] || product,
      data: [],
      counts: [],
      backgroundColor: COLORS[index % COLORS.length],
      stack: "stacked",
    })),
  };

  months.forEach((month) => {
    const weeks = groupedByMonth[month];
    weeks.forEach((week) => {
      if (!chartData.labels.includes(week.weekLabel)) {
        chartData.labels.push(week.weekLabel);
      }

      products.forEach((product, index) => {
        const revenueObj = week.revenue[product] || { amount: 0, count: 0 };
        chartData.datasets[index].data.push(revenueObj.amount);
        chartData.datasets[index].counts.push(revenueObj.count);
      });
    });
  });

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        mode: "index",
        intersect: false,
        callbacks: {
          label: function (context) {
            const product = context.dataset.label;
            const revenue = context.formattedValue;
            const count = context.dataset.counts?.[context.dataIndex] ?? 0;
            return `${product}: ₹${revenue}, (Count: ${count})`;
          },
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    scales: {
      x: {
        stacked: true,
        title: {
          display: true,
          text: "Weeks",
        },
      },
      y: {
        stacked: true,
        title: {
          display: true,
          text: "Revenue (₹)",
        },
      },
    },
  };

  // function getCurrentWeekLabel() {
  //   const now = new Date();

  //   // Get the first day of the current month
  //   const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);

  //   // Get current date and day of the month
  //   const dayOfMonth = now.getDate();

  //   // Calculate week number (0-based, so add 1)
  //   const weekNumber = Math.ceil((dayOfMonth + firstDayOfMonth.getDay()) / 7);

  //   // Get month name (e.g., "May")
  //   const monthName = now.toLocaleString("default", { month: "long" });

  //   return `${monthName}-Week ${weekNumber}`;
  // }

  function getCurrentWeekLabel() {
    const now = new Date();

    // Get the first day of the current month
    const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);

    // Get current date and day of the month
    const dayOfMonth = now.getDate();

    // Calculate week number (0-based, so add 1)
    const weekNumber = Math.ceil((dayOfMonth + firstDayOfMonth.getDay()) / 7);

    // Get short month name (e.g., "Jun")
    const monthName = now.toLocaleString("default", { month: "short" });

    return `${monthName}-Week ${weekNumber}`;
  }

  return (
    <>
      <div className="card p-4">
        <h3 className="card-title">Weekly Product Revenue</h3>
        <Bar data={chartData} options={options} />
      </div>

      <div className="card mt-5">
        <div className="table-responsive">
          <table className="table table-vcenter">
            {/* <thead>
              <tr>
                <th>Sr</th>
                <th>Week</th>
                <th>Farm Tranning</th>
                <th>S.I</th>
                <th>H.M</th>
                <th>All Other</th>
                <th>S.I Kit</th>
                <th>AIF Report</th>
                <th>Total Revenue</th>
              </tr>
            </thead>
            <tbody>
              {console.log('current month ', currentMonthData)}
              {currentMonthData.map((item, index) => (
                <>
                  <tr
                    key={index}
                    style={{
                      backgroundColor:
                        item.weekLabel === getCurrentWeekLabel()
                          ? "rgb(12, 166, 120,0.1)"
                          : "",
                    }}
                  >
                    <td>{index + 1}</td>
                    <td>{item.weekLabel}</td>
                    {products.map((product, i) => (
                      <td key={i}>
                        ₹{item.revenue?.[product]?.amount ?? 0} (
                        {item.revenue?.[product]?.count ?? 0}){" "}
                      </td>
                    ))}
                    <td>₹{item?.total}</td>
                  </tr>
                </>
              ))}
            </tbody> */}
            <thead>
              <tr>
                <th className="p-3">
                  <span className="fs-2">Sr</span>
                </th>
                <th>
                  <span className="fs-2">Weeks In Month</span>
                </th>
                {products.map((product, index) => (
                  <th key={index}>
                    <span className="fs-2">
                      {product === "practical training"
                        ? "Farm Training"
                        : product}
                    </span>
                  </th>
                ))}
                <th>
                  <span className="fs-2">
                    <b>Total Revenue</b>
                  </span>
                </th>
              </tr>
            </thead>

            <tbody>
              {currentMonthData.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor:
                      item.weekLabel === getCurrentWeekLabel()
                        ? "rgba(12, 166, 120, 0.1)"
                        : "rgba(255, 255, 0, 0.2)",
                  }}
                >
                  <td>
                    <span className="fs-2">
                      <b>{index + 1}</b>
                    </span>
                  </td>
                  <td>
                    <span className="fs-2">
                      <b>{item.weekLabel}</b>
                    </span>
                  </td>

                  {products.map((product, i) => (
                    <td key={i}>
                      <span className="fs-2">
                        <b>
                          {" "}
                          ₹{item.revenue?.[product]?.amount ?? 0} (
                          {item.revenue?.[product]?.count ?? 0})
                        </b>
                      </span>
                    </td>
                  ))}

                  <td>
                    <span className="fs-2">
                      <b>₹{item?.total}</b>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default WeeklyRevenueChart;
